<script>
export default {
    name: "PrintBalanceSheet",

    data() {

        return {
            balances: []
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchBalanceSheet(), ]).then(() => {
            this.$root.loading = false;

            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchBalanceSheet() {
            let url = `Accounting/GetBalanceSheet`;
                url += `?AsAt=${this.$route.query.from}`;
                url += `&UserName=${this.$root.username}`;

            return this.$http.get(url).then(({ data }) => {
                this.balances = data;
            }).catch(() => {});
        },
    }
}
</script>
<template>
<div class="w-full flex flex-wrap">
        <div class="w-full p-2">
            <h2 class="text-lg font-bold">Balance Sheet</h2>
        </div>
        <div class="w-full">
            <table class="table border" id="table-balance-sheet">
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Assets</th>
                            <th class="py-tiny whitespace-nowrap"></th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Fixed Assets</th>
                            <th class="py-tiny whitespace-nowrap"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.sortname == ` Fixed Assets`)" 
                            :key="`_4_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : '0.00' }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Total Fixed Assets</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `Total Fixed Assets`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => bal.particulars == `Total Fixed Assets`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Current Assets</th>
                            <th class="py-tiny whitespace-nowrap"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.sortname == `Current Assets`)" 
                            :key="`_2_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.particulars == `Other Assets`)" 
                            :key="`_12_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                        <tr class="border-b-2">
                            <th class="py-tiny whitespace-nowrap">
                                Total Current Assets</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `Total Current Assets`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => bal.particulars == `Total Current Assets`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.particulars == `Total Other  Assets`)" 
                            :key="`_02_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Total Assets</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `TOTAL ASSETS`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => bal.particulars == `TOTAL ASSETS`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Liabilities</th>
                            <th class="py-tiny whitespace-nowrap">
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.sortname == ` Current Liabilities`)" 
                            :key="`_022_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Total Current Liabilities</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `Total Current Liabilities`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => bal.particulars == `Total Current Liabilities`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.particulars == ` Long Term Liabilities`)" 
                            :key="`_021_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                Total Long Term Liabilities</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `Total Long Term Liabilities`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => 
                                        bal.particulars == `Total Long Term Liabilities`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                TOTAL LIABILITIES</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `TOTAL LIABILITIES`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => 
                                        bal.particulars == `TOTAL LIABILITIES`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                NET ASSETS</th>
                            <th class="py-tiny whitespace-nowrap">
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100 text-sm border-b-2">
                        <tr class="border-b-2" 
                            v-for="(balance, idx) in balances.filter(bal => bal.particulars == `Profit of the Year`)" 
                            :key="`_0212_${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny">
                                {{ balance.particulars }}
                            </td>
                            <td class="py-tiny">
                                {{ balance.value ? $formatCurrency(balance.value) : 0.00 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="bg-gray-200 text-sm border-b-2">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                TOTAL LIABILITIES AND STOCKHOLDERS EQUITY</th>
                            <th class="py-tiny whitespace-nowrap">
                                {{
                                    balances.filter(bal => bal.particulars == `TOTAL LIABILITIES AND STOCKHOLDERS EQUITY`).length
                                    ?
                                    $formatCurrency(balances.filter(bal => 
                                        bal.particulars == `TOTAL LIABILITIES AND STOCKHOLDERS EQUITY`)[0].value)
                                    :
                                    '0.00'
                                }}
                            </th>
                        </tr>
                    </thead>
                </table>
        </div>
    </div>
</template>